import { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import './login.scss';

const logo = require('assets/images/CMC_Logo.png');

const Login: FC = () => {
  const forgotPasswordURL = useMemo(() => {
    const url = new URL('/forgotPassword', process.env.REACT_APP_COGNITO_URI);
    url.searchParams.append('client_id', `${process.env.REACT_APP_COGNITO_CLIENT_ID}`);
    url.searchParams.append('response_type', 'code');
    url.searchParams.append('scope', 'aws.cognito.signin.user.admin');
    url.searchParams.append('redirect_uri', `${process.env.REACT_APP_REDIRECT_URI}`);
    return url.toString();
  }, []);

  return (
    <div className="login-component">
      <div className="login-banner d-flex justify-content-center align-items-center h-100">
        <div
          className="login-links bg-primary-dark flex-column d-flex align-items-center justify-content-center"
          style={{ gap: '1.5rem', padding: '2rem' }}
        >
          <img src={logo} alt="CMC Logo" style={{ maxWidth: '250px', marginBottom: '1rem' }} />

          <Link className="btn-primary-light w-100 text-center" to="/cognito">
            LOG IN
          </Link>

          <Link className="text-base text-underline text-white mt-2" to={forgotPasswordURL}>
            Forgot Password?
          </Link>

          {/* <Link
            className="align-self-center text-base text-underline text-white"
            to="https://view.forms.app/tsiatta/vem-gate-registration"
          >
            Not registered? Sign up.
          </Link> */}

          <Link className="btn-secondary w-100 text-center mt-3" to="/interchange-lookup">
            Interchange lookup
          </Link>

          <div className="notification-warning">
            <strong>Important Notice:</strong> We recently completed a system transition. Beginning Monday, June 22,
            2026, please use the new URL to access the system. Your account still exists, but your previous password
            will no longer work after the transition. To regain access, please select{' '}
            <Link to={forgotPasswordURL}>Forgot Password</Link> on the new login page and create a new password before
            signing in. Please note that the new URL and password reset process will not work properly before{' '}
            <strong>Monday, June 22, 2026.</strong> Do not attempt to reset your password or make changes to your
            account before this date.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;